/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterPiiKind = (typeof FilterPiiKind)[keyof typeof FilterPiiKind];

export const FilterPiiKind = {
  pii: 'pii',
} as const;
